export default __webpack_public_path__ + "static/media/sustainability15.fdc0cbfe.webp";